import React, { useEffect, useState } from 'react';
import CrossLargeSVG from 'Components/Admin/assets/CrossLargeSVG';

const withSubmitButtons = (Component) => {
  return ({ fieldProps: { onChange, value, ...fieldProps }, buttons, onClose, ...props }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [currentValue, setCurrentValue] = useState(value || '');

    const handleFocus = () => setIsOpen(true);
    const handleChange = (e) => setCurrentValue(e.target.value);

    const handleClose = () => {
      setIsOpen(false);
      setCurrentValue('');
      if (onClose) onClose();
    };

    useEffect(() => {
      if (currentValue !== value) setCurrentValue(value);
    }, [value]);

    const handleSubmit = () => {
      setIsOpen(false);
      onChange(currentValue);
    };

    return (
      <div className="admin-form__submit-panel-wrapper">
        <Component
          callback={handleChange}
          fieldProps={{
            onFocus: handleFocus,
            value: currentValue,
            ...fieldProps,
          }}
          {...props}
        />
        {isOpen && (
          <div className="admin-form__submit-panel" data-testid={`${fieldProps.name}-submit-panel`}>
            <div className="admin-form__submit-panel__group">
              <button
                className="admin-form__submit-panel__group__submit-btn"
                onClick={handleSubmit}
              >
                Save
              </button>
              <button
                className="admin-form__submit-panel__group__close-btn"
                onClick={handleClose}
              >
                <CrossLargeSVG />
              </button>
            </div>
            {buttons && buttons.map((button, index) => <div key={index}>{button}</div>)}
          </div>
        )}
      </div>
    );
  };
};

export default withSubmitButtons;
